module.exports = __webpack_public_path__ + "fonts/quicksand-v20-latin-700.4923618e.woff";